import type { SuggestionState } from '@stores/suggestion/suggestion-ngrx.reducer';

import { createAction, props } from '@ngrx/store';

export const suggestionGetEligible = createAction('[Suggestion] Get Eligible');
export const suggestionGetEligibleSuccess = createAction(
  '[Suggestion] Get Eligible Success',
  props<{ suggestionListing: SuggestionState }>()
);
export const suggestionGetEligibleError = createAction('[Suggestion] Get Eligible Error');
export const eligibleSuggestionsSet = createAction(
  '[EligibleSuggestions] Set',
  props<{ newEligibleSuggestionState: SuggestionState }>()
);
export const suggestionClear = createAction('[EligibleSuggestions] Clear');
